import { MDBBtn } from 'mdbreact';
import { FaRedo } from 'react-icons/fa';
import * as BsIcons from 'react-icons/bs';
import Consierge from '../images/consierge-greet-avatar.png';

import { toolTippy } from '../components/Utils.js';
import Const from '../components/Const';
import * as TiIcons from 'react-icons/ti';

// Post buttons and icons except X-closer and Emoji, which is in GetPost class

export function getButton(that) {
  // save post / update post
  let buttonText = (that.getHeader() === "Update Post") ? "Update" : "Post";
  let cond;

  if (that.state.isModalWindowEnabled) {
    // when enabled keep the oroginal post/update button condition
    cond = (that.state.noPostText && that.state.imageIsNotUploaded) || that.textOverflow
  }
  else {
    cond = true; // disabled button
  }
  return (
    cond
    ? <MDBBtn id="dialog-button" className="btn btn-primary pointer-noview"  disabled = { true }>{ buttonText }</MDBBtn>
    : <MDBBtn id="dialog-button" className="btn btn-primary" type="submit" value="Submit">{ buttonText }</MDBBtn>
  )
}

export function getAILayoutToggle(that) {
  // Toogle switch
  let videoLayoutToggleIsEnabled = that.state.videoLayoutToggleIsEnabled;
  let layout = that.state.videoLayout;
  let loginUser = that.state.grandParent.state.loginUser;
  let aiLimitCond = that.aiImageLimitCondition(loginUser);
  let isDisabled = (!aiLimitCond || !that.state.submitToAINotSentYet ); 
  let reducedOpacityClass = isDisabled ? 'toggle-disable': '';
  let pointerClass = isDisabled ? 'pointer-noview': 'pointer-view';

  const handleToggle = () => {
    const newLayout = layout === that.LANDSCAPE ? that.PORTRAIT : that.LANDSCAPE;
    that.setState({ videoLayout: newLayout });
  };

  if (videoLayoutToggleIsEnabled) {
    return (
      <div className={`toggle-container ${reducedOpacityClass}`}>
        <label className={`toggle-switch ${pointerClass}`}>
          <input 
            type="checkbox"
            checked={layout === that.PORTRAIT}
            onChange={ handleToggle }
            disabled={ isDisabled }
          />
          <span className="slider"></span>
        </label>
        <p className="toggle-label">
          {layout === that.LANDSCAPE ? "Landscape" : "Portrait"}
        </p>
      </div>
    );
  }
  else {
    return null;
  }
}

export function getUploadImageIckon(that) {
  if (that.state.isModalWindowEnabled) {
    return (
      <div className="previewComponent">
        <label id="label" htmlFor="oneimage" >
          <div className="media-icon">
          { toolTippy(BsIcons.BsImageAlt, "Upload Image or Video", "bottom", [Const.DELAY, 0], "icon", null) }
          </div>
        </label>
        <input className="fileInput hidden" id="oneimage" 
          type="file" 
          accept={Const.ACCEPTED_IMAGE_TYPES}
          onChange={that.handleImageChange}
          onClick={ that.handleUploadImageClick }
        />
      </div>
      )
  }
  else {
    return (
      <div className="previewComponent">
        <label id="label" className="pointer-noview">
          <div className="media-icon">
            { toolTippy(BsIcons.BsImageAlt, "Upload Image or Video", "bottom", [Const.DELAY, 0], "icon pointer-noview", null) }
          </div>
        </label>
      </div>
    )
  }
}

export function getToAIIckon(that) {
  if (that.state.isModalWindowEnabled) {
    return (
      <div className="previewComponent">
        <label id="labelAI" className="pointer-view">
           <div className="avatar-ai-sm" onClick={ () => that.higlightSelectedElement('button1')} >
              { toolTippy( Consierge, "Ask AI Concierge", "bottom", [Const.DELAY, 0], "", null) }
            </div>
        </label>
      </div>
    )
  }
  else {
    return (
      <div className="previewComponent">
        <label id="labelAI" className="pointer-noview">
            <div className="avatar-ai-sm" >
              { toolTippy( Consierge, "Ask AI Concierge", "bottom", [Const.DELAY, 0], "", null) }
            </div>
        </label>
      </div>
    )
  }
}

export function getAivideoInfoIcon(that) {
  let numOfAIvideoTries = that.state.numOfAIvideoTries;
  let dataTip = `You have ${numOfAIvideoTries} complimentary attempts to re-generate this video within an hour.`;

  if (that.state.isModalWindowEnabled) {
    return (
      <div className="previewComponent">
            <div className="media-icon">
              { toolTippy(TiIcons.TiInfoOutline, dataTip, "bottom", [Const.DELAY, 0], "media-icon", null, true) }
            </div>
      </div>
    )
  }
  else {
    return (
      <div className="previewComponent">
            <div className="media-icon pointer-noview">
              { toolTippy(TiIcons.TiInfoOutline, dataTip, "bottom", [Const.DELAY, 0], "media-icon pointer-noview", null) }
            </div>
      </div>
    )
  }
}

export function getRetryAivideoIcon(that) {
  if (that.state.isModalWindowEnabled) {
    return (
      <div className="previewComponent">
            <div className="media-icon"  onClick={ () => that.retryVideoRequest()} >
                { toolTippy(FaRedo, "Retry AI Video", "bottom", [Const.DELAY, 0], "icon", null) }
            </div>
      </div>
    )
  }
  else {
    return (
      <div className="previewComponent">
            <div className="media-icon pointer-noview">
                { toolTippy(FaRedo, "Retry AI Video", "bottom", [Const.DELAY, 0], "icon pointer-noview", null) }
            </div>
      </div>
    )
  }
}